export enum OFFER_TYPE {
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount',
  QUANTITY = 'quantity',
  SPEND_FOR_GIFT = 'spend_for_gift',
  VOUCHER = 'voucher',
}
